// extracted by css-extract-rspack-plugin
var _1 = "k2oV6zQo8tUt2yHK";
var _2 = "quTHFO7hvkTD0_53";
var _3 = "vZyyGTFnR_sL3BFl";
var _4 = "vPnVhcENdlQq26uU";
export { _1 as "buttonStyle", _2 as "buttonsWrapperStyle", _3 as "modalCloseButtonStyle", _4 as "wrapperStyle" }
